/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import deleteNombreCentreActions, {
    deleteNombreCentreTypes,
} from '../../../redux/nombreCentreFormationsPrivees/deleteNombreCentrePrive'
import getAllPrivateCentreActions from '../../../redux/nombreCentreFormationsPrivees/getAllPrivateCenters'
import { Delete } from '../../../serveur/axios'

function* deleteNombreCentreSagas({ response }) {
    try {
        const res = yield Delete(
            `collect_data/private_training_center/${response.id}`
        )

        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(
                    deleteNombreCentreActions.deleteNombreCentreSuccess(
                        res.data
                    )
                ),
                yield put(
                    getAllPrivateCentreActions.getAllPrivateCentersRequest()
                ),
            ])
        } else {
            yield put(deleteNombreCentreActions.deleteNombreCentreFailure(res))
        }
    } catch (error) {
        yield put(deleteNombreCentreActions.deleteNombreCentreFailure(error))
    }
}

export function* deleteNombreCentreSaga() {
    yield takeLatest(
        deleteNombreCentreTypes.DELETE_NOMBRE_CENTRE_REQUEST,
        deleteNombreCentreSagas
    )
}
